import { ChangeDetectionStrategy, Component } from "@angular/core";
import { ICellRendererAngularComp } from "@bfx/ag-grid-angular";
import LoggerService from "@bfx/logger/dist";
import { TranslateService } from "@ngx-translate/core";
import { ICellRendererParams } from "ag-grid-community/main";

import { BmarkRiskInstrumentRendererComponent } from "app/bfx-bmark-summary/blotters/spot-risk/renderers/bmark-risk-instrument-renderer.component";
import { InstrumentColumnData } from "shared/cubiq-services/model/benchmarks/BmarkSpotRisk.constants";
const logger = LoggerService.for(__dirname);

/**
 * Renderer for Instrument in benchmark Fwd Risk blotter
 */
@Component({
  selector: "fwd-risk-instrument",
  templateUrl: "./bmark-fwd-risk-instrument.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class BmarkFwdRiskInstrumentRendererComponent
  extends BmarkRiskInstrumentRendererComponent
  implements ICellRendererAngularComp
{
  public hidden: boolean = false;
  public lastInstrumentRow: boolean = false;

  /**
   * BmarkFwdRiskInstrumentRendererComponent is immutable' after agInit() due to refresh() returning false
   *
   * Change from ag-grid will destroy component and create a new one
   *
   * A ChangeDetectorRef push (markForCheck) must never be called
   */
  constructor(protected translator: TranslateService) {
    super(translator);
  }

  protected processParams(params: ICellRendererParams): void {
    this.hidden = false;
    if (params != null && params.value != null && params.value instanceof InstrumentColumnData) {
      let data: InstrumentColumnData = params.value;
      this.warningOverlayEnabled = false;
      this.instrument = data.instrument;
      this.hasFwdOrders = false;
      this.hidden = false;
      this.lastInstrumentRow = false;

      if (params.rowIndex > 0) {
        const previousRow = params.api.getDisplayedRowAtIndex(params.rowIndex - 1);
        const previousValue = params.api.getValue(params.column, previousRow);

        if (previousValue instanceof InstrumentColumnData) {
          this.hidden = this.instrument === previousValue.instrument;
        }
      }

      if (params.rowIndex < params.api.getDisplayedRowCount()) {
        const nextRow = params.api.getDisplayedRowAtIndex(params.rowIndex + 1);
        const nextValue = params.api.getValue(params.column, nextRow);

        if (nextValue instanceof InstrumentColumnData) {
          this.lastInstrumentRow = this.instrument !== nextValue.instrument;
        }
      }
    }
  }
}
